import { render, staticRenderFns } from "./Erfb.vue?vue&type=template&id=6b944b31"
import script from "./Erfb.vue?vue&type=script&lang=js"
export * from "./Erfb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports